import React from 'react'
import styled from 'styled-components'

const BuildingEntryChoice = ({ onNewBuild, onExistingBuilding }) => (
  <Wrapper>
    <Eyebrow>Before you start</Eyebrow>
    <Title>Was the building completed more than 6 months ago?</Title>
    <Text>
      Newer buildings are often not in the OS address data yet, so the map can
      show the wrong units or none at all. For a newer building, fill in the
      address by hand and sync the units from the Building Passport once they
      appear in the OS address data.
    </Text>
    <Actions>
      <PrimaryButton type='button' onClick={onExistingBuilding}>
        Yes, use the map
      </PrimaryButton>
      <SecondaryButton type='button' onClick={onNewBuild}>
        No, fill in manually
      </SecondaryButton>
    </Actions>
  </Wrapper>
)

export default BuildingEntryChoice

const Wrapper = styled.div`
  max-width: 620px;
  padding: 8px 0 12px;
`

const Eyebrow = styled.div`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const Title = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.haiti};
  font-size: 28px;
  font-weight: 700;
  line-height: 1.12;
`

const Text = styled.p`
  margin: 10px 0 0;
  color: rgba(12, 18, 41, 0.68);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.55;
`

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
`

const PrimaryButton = styled.button`
  min-height: 44px;
  padding: 0 18px;
  border: 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
`

const SecondaryButton = styled.button`
  min-height: 44px;
  padding: 0 18px;
  border: 1px solid rgba(12, 18, 41, 0.14);
  border-radius: 8px;
  background: #ffffff;
  color: ${({ theme }) => theme.colors.haiti};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`
